export default "__VITE_ASSET__DYLsVWEN__"